module.exports = __webpack_public_path__ + "static/img/Balloons.007e5405.png";